import React, { useState, useRef, useEffect } from 'react';
import '../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import { getClonedChild } from '../../utils/componentHelpers.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import { useEnhancedEffect } from '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { isBrowser } from '../../utils/dom.es.js';
import { useUpdateEffect } from '../../hooks/useUpdateEffect/useUpdateEffect.es.js';
import 'react-beautiful-dnd';
import 'nanoid/non-secure';
import { Collapse, CollapseTitle, CollapseIcon, CollapseContentWrapper } from './styled.es.js';
import { getContentHeight } from './helpers.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const BaseCollapse = (_a) => {
  var _b = _a, {
    children,
    isOpen,
    onOpen,
    onClose,
    onToggle,
    variant = "default",
    className,
    hasTitleClick = true
  } = _b, props = __objRest(_b, [
    "children",
    "isOpen",
    "onOpen",
    "onClose",
    "onToggle",
    "variant",
    "className",
    "hasTitleClick"
  ]);
  const [hasTitleHover, setHasTitleHover] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const [dimensions, setDimensions] = useState({
    height: isBrowser ? window.innerHeight : 0,
    width: isBrowser ? window.innerWidth : 0
  });
  const contentRef = useRef(null);
  const childrenArray = children ? React.Children.toArray(children) : [];
  const title = getClonedChild(childrenArray, "Collapse.Title", __spreadValues({
    variant,
    hasTitleHover,
    isOpen
  }, props));
  const trigger = getClonedChild(childrenArray, "Collapse.Trigger", __spreadValues({
    onClick: onToggle
  }, props));
  const content = getClonedChild(childrenArray, "Collapse.Content", {
    ref: contentRef
  });
  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      });
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useUpdateEffect(() => {
    isOpen ? onOpen == null ? void 0 : onOpen() : onClose == null ? void 0 : onClose();
  }, [isOpen, onClose, onOpen]);
  useEnhancedEffect(() => {
    setContentHeight(getContentHeight(contentRef));
  }, [content, dimensions]);
  const activateTitleHover = () => setHasTitleHover(true);
  const deactivateTitleHover = () => setHasTitleHover(false);
  return /* @__PURE__ */ React.createElement(Collapse, {
    hasTitleHover,
    className
  }, /* @__PURE__ */ React.createElement(CollapseTitle, __spreadValues({
    "aria-expanded": isOpen,
    onClick: hasTitleClick ? onToggle : void 0,
    onMouseEnter: hasTitleClick ? activateTitleHover : void 0,
    onMouseLeave: hasTitleClick ? deactivateTitleHover : void 0,
    hasTitleHover: hasTitleClick,
    isOpen
  }, props), title, trigger ? trigger : /* @__PURE__ */ React.createElement(CollapseIcon, {
    isOpen,
    hasTitleHover,
    hasTitleClick,
    variant,
    size: "md",
    onClick: !hasTitleClick ? onToggle : void 0
  })), /* @__PURE__ */ React.createElement(CollapseContentWrapper, {
    isOpen,
    contentHeight
  }, content));
};

export { BaseCollapse };
//# sourceMappingURL=BaseCollapse.es.js.map
